import {mergeWith} from '@chakra-ui/utils'
import Button from '../base/button'

// Styles for the StyledContent component
export default {
    baseStyle: (ctx) => {
        const {theme} = ctx
        return {
            sx: {
                h1: {
                    ...theme.textStyles['Regular 45XLarge'],
                    marginBottom: '1em'
                },
                h2: {
                    ...theme.textStyles['Regular 2XLarge'],
                    marginBottom: '1em'
                },
                h3: {
                    ...theme.textStyles['Regular XLarge'],
                    marginBottom: '1em'
                },
                h4: {
                    ...theme.textStyles['Semi Bold Medium'],
                    marginBottom: '1em'
                },
                p: {
                    ...theme.textStyles['Regular Medium'],
                    marginBottom: '1em'
                },
                div: {
                    marginBottom: '1em'
                },
                a: mergeWith(
                    {},
                    theme.components.Link.baseStyle,
                    theme.components.Link.variants.core(ctx)
                ),
                table: {
                    border: '1px solid',
                    borderCollapse: 'collapse',
                    padding: '1.07375rem',
                    marginBottom: '1em'
                },
                th: {
                    ...theme.textStyles['Semi Bold Small'],
                    border: '1px solid',
                    borderCollapse: 'collapse',
                    padding: '1.07375rem',
                    textAlign: 'left'
                },
                td: {
                    ...theme.textStyles['Regular Small'],
                    border: '1px solid',
                    borderCollapse: 'collapse',
                    padding: '1.07375rem'
                },
                ul: {
                    listStyleType: 'disc',
                    listStylePosition: 'outside',
                    paddingLeft: '1.375rem',
                    marginBottom: '1em'
                },
                '.sk-regular-xl': {
                    ...theme.textStyles['Regular XLarge']
                },
                '.sk-regular-4_5xl': {
                    ...theme.textStyles['Regular 4.5XLarge']
                },
                '.sk-regular-4xl': {
                    ...theme.textStyles['Regular 4XLarge']
                },
                '.sk-regular-2xl': {
                    ...theme.textStyles['Regular 2XLarge']
                },
                '.sk-semibold-medium': {
                    ...theme.textStyles['Semi Bold Medium']
                },
                '.sk-regular-medium': {
                    ...theme.textStyles['Regular Medium']
                },
                '.sk-light-medium': {
                    ...theme.textStyles['Light Medium']
                },
                '.sk-regular-small': {
                    ...theme.textStyles['Regular Small']
                },
                '.sk-semibold-small': {
                    ...theme.textStyles['Semi Bold Small']
                },
                '.sk-regular-badges': {
                    ...theme.textStyles['Regular Badges']
                },
                '.sk-usp-list': {
                    listStyleType: 'none',
                    pl: '6',
                    '> li': {
                        _before: {
                            content: '"✓"',
                            ml: '-5',
                            mr: '2'
                        },
                        '&:not(:last-of-type)': {
                            mb: '4'
                        }
                    }
                },
                ol: {
                    paddingLeft: '1.375rem',
                    marginBottom: '1em'
                },
                button: {
                    ...Button.baseStyle,
                    ...Button.variants.solid({
                        theme,
                        colorScheme: 'stokkeCore',
                        textStyle: 'Regular Medium'
                    })
                },
                '.sk-button': {
                    display: 'inline-flex',
                    alignItems: 'center',
                    ...Button.baseStyle,
                    ...Button.variants.solid({
                        theme,
                        colorScheme: 'stokkeCore',
                        textStyle: 'Regular Medium'
                    })
                }
            }
        }
    }
}
